// extracted by mini-css-extract-plugin
export default {"innerWrapper":"hA-z","tooltipWrapper":"iA-z","icon":"jA-z","tooltip":"kA-z","content":"lA-z"};